import { render, staticRenderFns } from "./subCategorias.vue?vue&type=template&id=29dfb5c8"
import script from "./subCategorias.vue?vue&type=script&lang=js"
export * from "./subCategorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports